import { useContext } from 'react';
import {
    ActionDependant,
    evaluateTemplateValue,
    GlobalDataContext,
    TemplateContext
} from "@ea-lab/reactive-json";

/**
 * FormattedDate component - Displays a formatted date
 * 
 * Usage in YAML:
 * - type: FormattedDate
 *   content: ~.createdAt
 *   format: "short"  # optional, defaults to "short"
 */
export const FormattedDate = ({ props }) => {
    const globalDataContext = useContext(GlobalDataContext);
    const templateContext = useContext(TemplateContext);

    // Evaluate the date value (supports template references like ~.createdAt)
    const dateValue = evaluateTemplateValue({
        valueToEvaluate: props.content,
        globalDataContext,
        templateContext
    });

    const format = props.format || "short";

    const formatDate = (value) => {
        if (!value) return "";
        
        try {
            const date = new Date(value);
            
            if (isNaN(date.getTime())) {
                return value; // Return original value if invalid date
            }
            
            if (format === "short") {
                // Format: 31/10/25-20:28
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = String(date.getFullYear()).slice(-2); // Last 2 digits
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                
                return `${day}/${month}/${year}-${hours}:${minutes}`;
            }
            
            // Default fallback
            return date.toLocaleString();
            
        } catch (error) {
            console.error("Error formatting date:", error);
            return value; // Return original value on error
        }
    };

    const formattedDate = formatDate(dateValue);

    return (
        <ActionDependant {...props}>
            {formattedDate}
        </ActionDependant>
    );
};
